import React, { useState } from 'react';
import ReactFileReader from 'react-file-reader';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import Text from '../../../../../Components/Base/Text/Text';
import styles from './ImageUpload.module.scss';
import Image from '../../Image/Image';

interface Props {
	onChange?: (image: string) => void;
	value?: string;
	previewStyle?: React.CSSProperties;
}

const ImageUpload: React.FC<Props> = ({ onChange, value, previewStyle }) => {
	const [image, setImage] = useState<string | undefined>(value);

	const handleFiles = (files: { base64: string }) => {
		if (files.base64) {
			setImage(files.base64);
			onChange?.(files.base64);
		}
	};

	return (
		<ReactFileReader
			fileTypes={['.png', '.jpg']}
			base64={true}
			handleFiles={handleFiles}>
			<div className={styles.wrapper}>
				<div className={styles.image} style={previewStyle}>
					{image ? (
						<Image src={image} />
					) : (
						<Text className={styles.title} tx='base.youCanSelectFileByPress' />
					)}
				</div>
				{image && (
					<LinkButton title='base.change' theme={Theme.BLUE} firstUpper />
				)}
			</div>
		</ReactFileReader>
	);
};

export default ImageUpload;
